import { injectable, interfaces } from 'inversify';
import { makeObservable, observable } from 'mobx';

export interface IBillingStore {
  usedSpace: number;
  workspaces: number;
  workspaceUsers: number;
}

export namespace IBillingStore {
  export const $: interfaces.ServiceIdentifier<IBillingStore> = Symbol('BILLING_STORE');
}

@injectable()
export class BillingStore implements IBillingStore {
  usedSpace: number = 0;
  workspaces: number = 0;
  workspaceUsers: number = 0;

  constructor() {
    makeObservable(this, {
      workspaces: observable,
      workspaceUsers: observable,
      usedSpace: observable,
    });
  }
}
